import React from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'

export const RelatedPurchaseOrderInlineInput = ({
  parentInputComponent,
  initialValues,
  displayContent,
  editContent,
  name = 'relatedPurchaseOrders',
  label = 'Purchase Orders',
  help = 'The related purchase orders for this item.',
  ...props
}: InlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput

  const mappedInitialValues = {
    ...initialValues,
    [name]: initialValues?.[name]?.map((item) => {
      return {
        ...item,
        value: item?._id,
        label: item.code,
      }
    }),
  }

  return (
    <ParentInput
      label={label}
      help={help}
      name={name}
      initialValues={mappedInitialValues}
      displayContent={displayContent}
      editContent={editContent}
      horizontalLayout
      {...props}
    />
  )
}
